import { Controller } from 'stimulus';

export default class CustomRangeInputController extends Controller {
  static targets = ['rangeInput', 'valueValue'];

  connect() {
    this.form = this.element.closest('form');
    this.min = Number(this.rangeInputTarget.min);
    this.max = Number(this.rangeInputTarget.max);

    this.rangeInputTarget.addEventListener('input', this._updateEverything);

    this.form.addEventListener('reset', this._handleFormReset, true);

    this._updateEverything();
  }

  disconnect() {
    this.rangeInputTarget.removeEventListener('input', this._updateEverything);
    this.form.removeEventListener('reset', this._handleFormReset, true);
  }

  _updateEverything = () => {
    const value = this.rangeInputTarget.value;

    const percentage = this._calculatePercentage(value, this.min, this.max);
    this.element.style.setProperty(
      '--percentage',
      `${Math.round(percentage)}%`,
    );

    if (this.hasValueValueTarget) {
      this.valueValueTarget.textContent = value;
    }
  };

  _calculatePercentage = (value, min, max) => {
    return ((Number(value) - min) / (max - min)) * 100;
  };

  _handleFormReset = () => {
    setTimeout(() => {
      this._updateEverything();
    }, 0);
  };
}
